export const QUOTE_APP_ROUTE = '/v2/quote-app';
